import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../../contexts/ProfileContext';
import UserMenu from '../account/UserMenu';
import './HomeTopBar.css';

const HomeTopBar = ({ onPointsClick, beforePills = null, afterCoins = null }) => {
  const { user, coins, seasonPoints } = useProfile();
  const navigate = useNavigate();

  return (
    <div className="home-topbar">
      {beforePills}

      {/* Points — only for logged-in users */}
      {user && (
        <button className="home-topbar-pill topbar-points" onClick={onPointsClick}>
          <span className="topbar-pill-emoji" role="img" aria-hidden="true">🏆</span>
          <span>{(seasonPoints ?? 0).toLocaleString()} pts</span>
        </button>
      )}

      {/* Coins — only for logged-in users */}
      {user && (
        <button className="home-topbar-pill topbar-coins" onClick={() => navigate('/coins')}>
          <span className="topbar-pill-coin" aria-hidden="true" />
          <span>{coins}</span>
        </button>
      )}

      {afterCoins}

      {/* Account — shows player name (signed in) or "Sign In" (guest) */}
      <div className="topbar-usermenu-wrapper">
        <UserMenu />
      </div>
    </div>
  );
};

export default HomeTopBar;
